// extracted by mini-css-extract-plugin
export default {"wrap":"TestsetList_wrap__QZFqt","body":"TestsetList_body__wn0FR","item":"TestsetList_item__SL2NR"};